import React from "react";
import { useSiteContent } from "../lib/siteContent";

// PlannioLife branded loading screen: the dog logo-mark with a soft breathing animation and a calm
// shimmer, giving a smooth transition instead of a partially-rendered page (issue 4).
export default function BrandedLoader({ label = "Loading", fullscreen = true }) {
  const sc = useSiteContent();
  return (
    <div
      data-testid="branded-loader"
      className={`flex flex-col items-center justify-center gap-5 bg-[#FAFAF8] ${fullscreen ? "min-h-screen" : "min-h-[240px] w-full rounded-3xl"}`}
    >
      <div className="relative flex items-center justify-center">
        <span className="absolute h-24 w-24 rounded-full bg-[#0F766E]/10 plannio-loader-pulse" />
        <img
          src={sc.brand_logo_mark || "/logo-mark.png"}
          alt="PlannioLife"
          className="theme-light-only relative h-16 w-16 object-contain plannio-loader-bob"
        />
        <img
          src={sc.brand_logo_mark_dark || "/logo-mark-white.png"}
          alt="PlannioLife"
          className="theme-dark-only relative h-16 w-16 object-contain plannio-loader-bob"
        />
      </div>
      <div className="flex flex-col items-center gap-3">
        <p className="font-display text-sm font-medium tracking-wide text-[#0F766E]">{label}</p>
        <div className="h-1 w-28 overflow-hidden rounded-full bg-[#0F766E]/10">
          <div className="h-full w-1/2 rounded-full bg-[#0F766E] plannio-loader-bar" />
        </div>
      </div>
      <style>{`
        @keyframes plannioBob { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-7px); } }
        @keyframes plannioPulse { 0%,100% { transform: scale(0.85); opacity: 0.45; } 50% { transform: scale(1.15); opacity: 0.15; } }
        @keyframes plannioBar { 0% { transform: translateX(-120%); } 100% { transform: translateX(240%); } }
        .plannio-loader-bob { animation: plannioBob 1.6s ease-in-out infinite; }
        .plannio-loader-pulse { animation: plannioPulse 1.8s ease-in-out infinite; }
        .plannio-loader-bar { animation: plannioBar 1.2s ease-in-out infinite; }
        @media (prefers-reduced-motion: reduce) {
          .plannio-loader-bob, .plannio-loader-pulse, .plannio-loader-bar { animation: none; }
        }
      `}</style>
    </div>
  );
}
